import type { DrillDownRunRecord } from "../widgets/types/core"

const getUsableId = (value: string | null | undefined): string | null => {
  const normalizedValue = value?.trim()
  return normalizedValue ? normalizedValue : null
}

export const buildDrillDownConversationPath = (
  row: Pick<DrillDownRunRecord, "run_id" | "simulation_output_id">,
): string => {
  const normalizedRunId = getUsableId(row.run_id)
  if (normalizedRunId) {
    return `/simulated/runs/${normalizedRunId}/results/${row.simulation_output_id}`
  }

  return `/simulations/${row.simulation_output_id}`
}

export const getDrillDownConversationLabel = (
  row: Pick<DrillDownRunRecord, "run_id" | "simulation_output_id">,
): string => {
  const normalizedRunId = getUsableId(row.run_id)
  if (normalizedRunId) {
    return `View details for simulation ${row.simulation_output_id} in run ${normalizedRunId}`
  }

  return `View details for simulation ${row.simulation_output_id}`
}
